import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectItem } from 'primeng';
import {
    address,
    blockSpecialCharachters,
    city,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    name_input,
    number_input,
    phoneNumber,
    textareaBox,
    zipCode
} from 'src/app/constant/constant';
import {
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { User_Registration } from 'src/app/models/User';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-forget-email-patient',
    templateUrl: './forget-email-patient.component.html',
    styleUrls: [
        './forget-email-patient.component.css',
        './../login-home/login-home.component.css'
    ]
})
@TraceClassDecorator()
export class ForgetEmailPatientComponent implements OnInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    logo_url: string = '';
    formPosting: boolean = false;
    isPassword: boolean = true;
    recaptcha_Reset: boolean = false;
    forgotEmailDone = false;
    userPatient: User_Registration = new User_Registration();
    countries: SelectItem[] = [];
    provider_id: string = "";
    response: PromiseResult = new PromiseResult();
    error: ErrorModel = new ErrorModel();
    serverError: ServerError = new ServerError();
    slug: string = "";

    max_date: Date;
    // date_of_birth_string: string = "";

    constructor(
        private readonly countriesservice: CountriesService,
        private readonly daterenderService: DaterenderService,
        private readonly userservice: UserService,
        private readonly utilitiesService: UtilitiesService,
        private providerStateService: ProviderStateService
    ) {
        this.max_date = this.utilitiesService.getMaxDate();
        // this.date_of_birth_string = this.max_date;
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.userPatient = new User_Registration();
        this.response = new PromiseResult();
        this.provider_id = this.providerStateService.getProviderId();
        await this.getCountries();
        this.reset_variables();
        this.recaptchaReset();
        this.logo_url = this.providerStateService.getLogoUrl();
    }

    async getCountries(): Promise<void> {
        await this.countriesservice
            .getCountries(this.provider_id)
            .toPromise()
            .then((countries) => {
                this.countries = countries.map((co) => {
                    return {
                        label: co.country_name,
                        value: co.id
                    }
                });
            });
    }

    recaptchaReset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000);
    }

    resolved(captchaResponse: string) {
        this.userPatient.recaptcha = captchaResponse;
    }

    reset_variables(): void {
        // this.registrationDone = false;
        this.response = new PromiseResult();
        // this.isPassword_Login = true;
        this.isPassword = true;
        this.forgotEmailDone = false;
        // this.forgotPasswordDone = false;
        // this.forgotDoctorPasswordDone = false;
        // this.forgotDoctorEmailDone = false;
        // this.resendDone = false;
        // this.loginDone = false;
        // this.authresult = { authtoken: "", userid: "", name: "", rememberme: false, userrole: [] }
        sessionStorage.clear();
    }

    async patientForgotEmailSubmit() {
        this.formPosting = true;
        this.recaptchaReset();
        //    await grecaptcha.reset();
        await this.patientForgotEmail();
    }

    async patientForgotEmail(): Promise<void> {
        this.formPosting = true;
        // this.userPatient.date_of_birth_date = new Date(this.date_of_birth_string);
        this.userPatient.country_id = Number(this.userPatient.country_id);
        this.userPatient.provider_id = this.providerStateService.getProviderId();
        this.userPatient.date_of_birth = this.daterenderService.render_data(
            this.userPatient.date_of_birth_date
        );
        await this.userservice
            .forgotEmail(this.userPatient)
            .toPromise()
            .then((result) => {
                this.response = result;
                this.formPosting = false;
                if (this.response.success == true) {
                    this.forgotEmailDone = true;
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.formPosting = false;
            });
    }

    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
